<template>
    <div>
        <slot name="loggedin" v-if="auth"></slot>
        <slot name="guest" v-else></slot>
    </div>
</template>

<script>
    import Auth from '../../Services/Auth';

    export default {
        props: {
            guest: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                service: Auth
            }
        },
        mounted() {
            this.service.guest = this.guest;
        },
        computed: {
            auth() {
                return !this.service.guest;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/AccountMenu.vue